var _style, _rect, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _path, _mask, _circle, _mask2, _circle2, _mask3, _use, _g, _circle3, _path2, _path3, _path4, _path5, _path6, _g2, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevtool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 1522 1522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".e{fill:#fff}.a{stroke:#fff}.b{stop-color:#fff}.c{stop-color:#1a237e}.d{stop-opacity:0}.f{stop-opacity:.12}")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "d",
    width: 1520,
    height: 1520,
    rx: 120
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: "15%",
    cy: "14%",
    r: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "b f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    className: "b d",
    offset: 1
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: "-.2%",
    cy: ".1%",
    r: "136%"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "c",
    offset: 0,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    className: "c d",
    offset: 1
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: "85%",
    cy: "13%",
    r: "154%"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "c f",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    className: "c d",
    offset: 1
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: "41%",
    cy: 0,
    r: "57%"
  }, /*#__PURE__*/React.createElement("stop", {
    className: "c",
    offset: 0,
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    className: "c d",
    offset: 1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M761 1361a600 600 0 100-1200 600 600 0 000 1200z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "j",
    width: 120,
    height: 120,
    x: 0,
    y: 0,
    className: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 761,
    cy: 761,
    r: 280
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "k",
    width: 56,
    height: 56,
    x: 0,
    y: 0,
    className: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "c",
    cx: 761,
    cy: 761,
    r: 200
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "l",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    className: "e"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#2879ff",
    xlinkHref: "#d"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeOpacity: 0.2,
    strokeWidth: 5,
    className: "a",
    xlinkHref: "#d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-199-199l1920 1920m0-1920L-199 1721M1038.5-199v1920m-555-1920v1920M1721 1038.5H-199m1920-555H-199"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 761,
    cy: 761,
    r: 390
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-199 761h1920M761-199v1920"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 761,
    cy: 761,
    r: 600,
    fill: "url(#f)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1400 0H120C54 0 0 54 0 120v10C0 64 54 10 120 10h1280c66 0 120 54 120 120v-10c0-66-54-120-120-120z",
    className: "e",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M1401 1511H121c-66 0-120-54-120-120v10c0 66 54 120 120 120h1280c66 0 120-54 120-120v-10c0 66-54 120-120 120z",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M495.9 675.8L251 431l267.2 458.3a273.7 273.7 0 01-22.4-213.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M820.7 1031L731 1365.6 996.6 901a274.2 274.2 0 01-176 130z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M962 575.3l334.2-89.3H759.7A273.7 273.7 0 10962 575.3z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 40,
    className: "a"
  }, /*#__PURE__*/React.createElement("use", {
    mask: "url(#j)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#k)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    mask: "url(#l)",
    xlinkHref: "#c"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M761 481h530v20H761zm242.5 420l-265 459-17.3-10 265-459zm-485 0l-265-459 17.3-10 265 459z",
    className: "e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevtool);
export default __webpack_public_path__ + "static/media/devtool.ceeeaee252a80f90807f00cb2cb517dd.svg";
export { ForwardRef as ReactComponent };